import React, { useEffect,useState } from 'react';
import { BaseTypography } from "src/components/common";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from 'react-router-dom';
import Pagination from "@material-ui/lab/Pagination";

const useStyles = makeStyles((theme) => ({
  root: {
      padding: '50px 20px'
  },
  card:{
      margin: "0 0 20px",
  },
  articleDescription: {
    color: '#555555',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    "& p":{
        margin: "0 0 10px",
    }
  },
  list:{
      fontSize: "1rem",
      listStyle: "auto",
      margin: "0 0 10px"
  },
  title:{
    color: "#000"
  },
  expertise: {
      display: "flex",
      gap: "10px",
      alignItems: "center",
  },
  link:{
      color: "#0090E5",
      textDecoration: "none"
  }
}));

type PAutoCard = {
    response: any;
};

const firstIndex = 0;

export const AuthorCard: React.FC<PAutoCard> = (props) => {
    const { response } = props;
    const classes = useStyles();

  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(1);
  const [data, setData] = useState(response.slice(firstIndex, pageSize));

  const handleChange = (event:any,value:any) => {
    console.log(value);
    setPage(value);
    setData(response.slice(firstIndex + pageSize * (value - 1), pageSize * value));
  };

  useEffect(() => {
    setData(response.slice(0, pageSize));
  }, [pageSize]);

    return (
      <>
          {
            data?.map((author:any)=>(
              <div key={author.id} className={classes.card}>
                <BaseTypography gutterBottom="true" variant="h3">
                  <Link className={classes.title} to={`/news/${author.slug}`}>
                    {author.title}
                  </Link>
                </BaseTypography>
                <BaseTypography className={classes.articleDescription} gutterBottom="true" dangerouslySetInnerHTML={{__html: author?.text}} />
                <BaseTypography variant="tag" className="pointer">
                    <Link className={classes.link} to={`/news/${author.slug}`}>
                      Read full article & Suggested experts
                    </Link>
                </BaseTypography>
              </div>
            ))
          }
          {response.length/pageSize > 1 &&
            <Pagination
                count={Math.ceil(response.length / pageSize)}
                page={page}
                onChange={handleChange}
                variant="outlined" 
                color="primary"
                shape="rounded"
            />
          }
      </>
    )
}